import React from "react";
//#region types
import { FileGridList } from "models/utilTypes/fileUtilsTypes";
//#endregion
//#region compnents
import { Grid } from "@mui/material";
import FilesGridItem from "./filesGridItem";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const FilesGrid: React.FC<FileGridList> = (props) => {
  return (
    <Grid item container className={cssExports.fileGridList}>
      {props.fileGridItems.map((fileGridItem, index) => {
        return (
          <FilesGridItem
            key={index}
            {...fileGridItem}
            onTileClick={props.onTileClick?.bind(null, index)}
          ></FilesGridItem>
        );
      })}
    </Grid>
  );
};

export default FilesGrid;
